import React from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Timer = ({ setUnclaimShow, isAllTranscriptLoad }) => {
  // EditorDetails Api's loading
  let editorDetailsLoading = useSelector((state) => state?.editorDetails?.loading);

  // EditorVendorDetails's Data
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data?.value);

  let editorDetailsData = editorDetails && JSON.parse(editorDetails);
  const allowEdit = editorDetailsData?.Status !== 'Rework';

  return (
    <>
      {editorDetailsLoading === false && (
        <Button
          variant="primary"
          className="w120 unclaim-btn"
          onClick={() => setUnclaimShow(true)}
          disabled={
            editorDetailsData?.ClaimCount > 2 || (isAllTranscriptLoad === false && editorDetailsLoading === false) || !allowEdit
          }
        >
          Unclaim
        </Button>
      )}
    </>
  );
};

export default Timer;
